import { render, staticRenderFns } from "./MappingsTab.vue?vue&type=template&id=a4dc547e&scoped=true"
import script from "./MappingsTab.vue?vue&type=script&lang=js"
export * from "./MappingsTab.vue?vue&type=script&lang=js"
import style0 from "./MappingsTab.vue?vue&type=style&index=0&id=a4dc547e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4dc547e",
  null
  
)

export default component.exports